<template>
  <div class="map-home">
    <div v-if="isOpenLink" @click="back" class="back">返回</div>
    <LinkIFrame style="width: 100%;height: 100vh;" :linkSrc="iframSrc" v-show="isOpenLink"></LinkIFrame>
    <div v-show="!isOpenLink" class="map-fake-container">
      <header v-if="activityInfo" class="banner"><img :src="activityInfo.bannerImage" alt="" /></header>
      <div id="map-container"></div>
      <shop-card
        v-if="nowSelectedInfo"
        style="position: fixed;bottom: 1.4rem;left: 50%;transform: translate(-50%, 0);z-index: 10;"
        :data="nowSelectedInfo"
        :userPosition="userPosition"
        v-show="!isShowShopList"
        mode="card"
        :activityInfo="activityInfo"
      ></shop-card>
      <footer
        v-if="shopDataSet"
        :style="{ transform: isShowShopList ? 'translate(0, 0)' : 'translate(0, calc(100% - 1.2rem))' }"
        class="show-shoplist"
      >
        <div @click="showShopList()" class="header">
          <div class="bar"></div>
          <div class="text">已展示{{ shopDataSet.length }}个结果</div>
        </div>
        <div class="list-container">
          <ul @scroll="handleScroll" class="list">
            <li v-for="(item, index) in shopDataSetList" :key="item.id + index" class="list-item">
              <shop-card
                :userPosition="userPosition"
                :activityInfo="activityInfo"
                v-if="item"
                :data="item"
                mode="list"
                :focusInMapById="focusInMapById"
              ></shop-card>
            </li>
          </ul>
        </div>
      </footer>
      <!-- 左右切换模式 -->
      <div v-if="activityInfo && activityInfo.categorieStyle === 'SLIDER'" class="slider-wrapper">
        <div class="slider">
          <img
            class="slider-item"
            @click="selectCate(item)"
            :key="item.uid"
            v-for="item in activityInfo.categories"
            :src="item.currentIcon"
          />
        </div>
      </div>
      <!-- 下拉形式 -->
      <div v-if="nowSelectCate && activityInfo && activityInfo.categorieStyle !== 'SLIDER'" @click="showSearchBox(true)" class="search-bar">
        <span v-if="activityInfo && activityInfo.categories && activityInfo.categories.length" class="channel">{{
          nowSelectCate.name
        }}</span>
        <img
          :style="{ transform: isShowSearchBox ? 'translate(0, -50%) rotate(180deg)' : 'translate(0, -50%)' }"
          src="../../assets/images/icon_down.png"
          alt=""
          class="icon"
        />
        <transition name="fade">
          <ul v-if="activityInfo && activityInfo.categories && activityInfo.categories.length" v-show="isShowSearchBox" class="select-box">
            <li @click.stop="selectCate()" :style="{ color: nowSelectCate.name == '全部分类' ? '#FA4744' : null }">全部分类</li>
            <li
              @click.stop="selectCate(item)"
              :style="{ color: nowSelectCate.name == item.name ? '#FA4744' : null }"
              v-for="item in activityInfo.categories"
              :key="JSON.stringify(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </transition>
      </div>
      <div @click="openLink" v-if="activityInfo && activityInfo.floatBtn && activityInfo.floatBtn.icon" class="merchant-entry">
        <img :src="activityInfo.floatBtn.icon" alt="" />
      </div>
      <div @click="fixLocation" class="fix-location"><img src="../../assets/images/icon_location.png" alt="" /></div>
      <transition name="fade">
        <div
          @click="
            () => {
              isShowSearchBox = false
            }
          "
          v-show="isShowSearchBox"
          class="mask"
        ></div>
      </transition>
      <div v-show="isShowMask" class="_mask"></div>
    </div>
  </div>
</template>

<script>
import shopCard from "@/components/ShopCard"
import { mapGetters, mapMutations, mapActions } from "vuex" //mapActions
import { getShopInfo, getActivityInfo } from "@/server/interfaces"
import setDocuemntTtitle from "@/utils/setDocumentTitle"
import changeRgbaToHex from "@/utils/changeRgbaToHex"
import { scale2Zoom, zoom2Scale } from "./utils/scale2Zoom"
import cleanPolygonData from "./utils/cleanPolygonData"
import LinkIFrame from "@/views/LinkIFrame/index.vue"
import { initShare } from "@/utils/share"
import { getDistance } from "@/utils/amap"
import { savePoint } from "@/utils/savePoint"
import { buryingPoint } from "@/utils/buryingPoint"

export default {
  components: {
    shopCard,
    LinkIFrame
  },
  data() {
    return {
      isShowShopList: false,
      isShowSearchBox: false,
      userPosition: null,
      defaultPosition: {
        latitude: 23.137,
        longitude: 113.325,
        valid: true
      },
      iframSrc: "",
      isOpenLink: false,
      mapMoveCenter: null,
      map: null,
      shopDataSet: null,
      activityInfo: null,
      nowSelectedInfo: null,
      nowSelectCate: {
        name: "全部分类"
      },
      distance: 20,
      page: 0,
      pageSize: 50,
      noMore: false,
      mapZoom: null,
      isShowMask: false,
      loopControl: false,
      refreshIcon: false,
      loading: false,
      marker: null,
      number: 1,
      polygonInstances: [],
      markerInstances: [],
      gdCityList: [],
      adCode: ""
    }
  },
  computed: {
    ...mapGetters({
      activityId: "activityInfo/activityId",
      storeActivityInfo: "activityInfo/activityInfo"
    }),
    shopDataSetList() {
      return this.shopDataSet.sort((prev, next) => prev.distance - next.distance)
    }
  },
  created() {
    savePoint({
      deviceid: window.localStorage.getItem("nfplus_deviceid"),
      dataType: "1000099",
      actionTime: Date.parse(new Date()),
      url: location.href || "",
      refer: document.referrer || "",
      origin: "9", // 9 - 信息地图H5
      action: "1", // 访问首页
      activityId: this.activityId || ""
    })
    document.onclick = e => {
      if (e && e.target && e.target.parentNode.classList.contains("icon-marker")) {
        this.handleClickIcon(e.target.parentNode)
      }
    }
  },
  async mounted() {
    await this.getActivityInfo()
    await this.initAMap()
    if (this.activityInfo.categorieStyle === "SLIDER") {
      this.nowSelectCate = this.activityInfo.categories[0]
      this.getShopInfo("init")
    }
    buryingPoint({ action: 1, sourceTag: 2, activityId: this.activityId, itemType: 1 })
  },
  methods: {
    ...mapMutations({
      toast: "toast/showToast",
      showLoading: "loading/showLoading",
      hideLoading: "loading/hideLoading",
      setShareInfo: "activityInfo/setShareInfo"
    }),
    ...mapActions({
      initNfPluseShare: "activityInfo/initNfPluseShare"
    }),
    back() {
      if (this.isOpenLink) {
        this.isOpenLink = false
      }
    },
    openLink() {
      this.iframSrc = this.activityInfo.floatBtn.jumpUrl
      this.isOpenLink = true
      buryingPoint({ action: 28, sourceTag: 2, activityId: this.activityId, itemType: 1 })
    },
    handleScroll(e) {
      let target = e.currentTarget
      let scrollTop = target.scrollTop
      let scrollHeight = target.scrollHeight
      let mapHeight = target.clientHeight
      if (scrollTop + mapHeight >= scrollHeight) {
        this.page++
        this.getShopInfo("update")
      }
    },
    selectCate(data) {
      if (this.activityInfo?.categorieStyle === "SLIDER") {
        this.activityInfo.categories.forEach(item => {
          if (item.uid === data.uid) {
            item.currentIcon = item.checkedIcon
          } else {
            item.currentIcon = item.unCheckedIcon
          }
        })
      }
      if (data) {
        this.nowSelectCate = data
        buryingPoint({ action: 27, sourceTag: 2, activityId: this.activityId, itemType: 1, optionName: data.name })
      } else {
        this.nowSelectCate = {
          name: "全部分类"
        }
        buryingPoint({ action: 26, sourceTag: 2, activityId: this.activityId, itemType: 1 })
      }
      this.mapMoveCenter = this.userPosition
      this.nowSelectedInfo = null
      this.distance = 20
      this.page = 0
      this.noMore = false
      this.shopDataSet = []
      this.map.add([])
      this.getShopInfo("init")
      this.showSearchBox()
    },
    matchIconImg(item) {
      if (
        this.activityInfo.categories.filter(info => info.uid == item.categoryId).length > 0 &&
        this.activityInfo.categories.filter(info => info.uid == item.categoryId)[0].icon
      ) {
        return this.activityInfo.categories.filter(info => info.uid == item.categoryId)[0].icon
      } else {
        return ""
      }
    },
    fixLocation() {
      this.distance = 20
      this.userPosition && this.map.setCenter([this.userPosition.longitude, this.userPosition.latitude])
      buryingPoint({ action: 29, sourceTag: 2, activityId: this.activityId, itemType: 1 })
    },
    focusInMapById(id) {
      console.log("focusInMapById", id)
      this.markerInstances.forEach(item => {
        if (item.getExtData().id === id) {
          this.map.setFitView([item], false)
          this.selectMarkerById(id)
          setTimeout(() => {
            this.selectMarkerById(id)
          }, 300) //没办法，setFitView没有回调函数，只能骚操作
          this.isShowShopList = false
          this.isShowMask = false
        }
      })
    },
    showShopList() {
      this.isShowShopList = !this.isShowShopList
      this.isShowMask = !this.isShowMask
      buryingPoint({ action: 30, sourceTag: 2, activityId: this.activityId, itemType: 1 })
    },
    showSearchBox(needBuryingPoint = false) {
      this.isShowSearchBox = !this.isShowSearchBox
      needBuryingPoint && buryingPoint({ action: 26, sourceTag: 2, activityId: this.activityId, itemType: 1 })
    },
    selectMarkerById(id) {
      let markerDoms = document.querySelectorAll(".icon-marker")
      markerDoms.forEach(item => {
        console.log("selectMarkerById", item.dataset.id, id)
        if (item.dataset.id === id) {
          console.log("selectMarkerById", item, id)
          this.handleClickIcon(item)
        }
      })
    },
    handleClickIcon(target) {
      this.initAmapMark()
      this.initAmapPolygon()
      target.parentNode.parentNode.style.zIndex = 150
      target.className = "icon shop-icon-box-active icon-marker"
      this.nowSelectedInfo = this.shopDataSet.find(item => item.id == target.dataset.id)
      this.selectPolygon(target.dataset.id)
      buryingPoint({ action: 15, sourceTag: 2, activityId: this.activityId, itemType: 1, optionId: target.dataset.id })
    },
    selectPolygon(id) {
      this.polygonInstances.forEach(item => {
        if (item.getExtData().id == id) {
          item.setOptions({ strokeOpacity: 1 })
        }
      })
    },
    initAmapMark() {
      let dom = Array.from(document.querySelectorAll(".icon-marker"))
      dom.forEach(item => {
        item.className = "icon shop-icon-box icon-marker"
        if (item.parentNode.parentNode) {
          item.parentNode.parentNode.style.zIndex = 100
        }
      })
    },
    async getActivityInfo() {
      this.showLoading()
      let detailRes = null
      if (this.storeActivityInfo) {
        detailRes = this.storeActivityInfo
      } else {
        detailRes = await getActivityInfo({
          params: {
            id: this.activityId
          }
        })
      }
      if (detailRes) {
        detailRes.categories = detailRes.categories.map((item, index) => {
          if (index === 0) {
            item.currentIcon = item.checkedIcon
          } else {
            item.currentIcon = item.unCheckedIcon
          }
          return item
        })
        this.activityInfo = detailRes
        setDocuemntTtitle(this.activityInfo.name)
        this.setShareInfo({
          title: this.activityInfo.share.shareTitle,
          desc: this.activityInfo.share.shareDesc,
          link: window.location.href,
          imgUrl: this.activityInfo.share.shareIcon
        })
        try {
          await this.initNfPluseShare()
        } catch (e) {
          window.console.log(e)
        }
        try {
          await initShare({
            shareTitle: this.activityInfo.share.shareTitle,
            shareUrl: window.location.href,
            shareIcon: this.activityInfo.share.shareIcon,
            shareDesc: this.activityInfo.share.shareDesc
          })
        } catch (e) {
          window.console.log(e)
        }
      } else {
        this.toast("活动信息获取失败")
        this.hideLoading()
        this.$router.replace("/nothingnessActivity")
      }
    },
    scale2Zoom(scale) {
      return scale2Zoom(scale)
    },
    zoom2Scale(zoom) {
      return zoom2Scale(zoom)
    },
    calcDistance(pointX, pointY) {
      let lnglat1 = new AMap.LngLat(pointX.longitude, pointX.latitude)
      let lnglat2 = new AMap.LngLat(pointY.longitude, pointY.latitude)
      return lnglat1.distance(lnglat2) / 1000
    },
    moveMapend() {
      this.map.getCity(info => {
        console.log("moveMapend info", info)
        const currentCityInfo = this.gdCityList.filter(item => item.citycode === info.citycode)[0]
        this.adCode = currentCityInfo?.adcode
        this.handleMoveMapend()
      })
    },
    handleMoveMapend() {
      let center = this.map.getCenter()
      this.mapMoveCenter = {
        latitude: center.lat,
        longitude: center.lng,
        valid: true
      }
      if (this.calcDistance(this.mapMoveCenter, this.userPosition) > this.distance && !this.loading) {
        this.noMore = false
        this.distance += this.calcDistance(this.mapMoveCenter, this.userPosition)
        this.number++
        // this.getShopInfo("move", this.number)
      }
      !this.loading && this.getShopInfoByMapAction()
    },
    mapZoomend() {
      this.map.getCity(info => {
        const currentCityInfo = this.gdCityList.filter(item => item.citycode === info.citycode)[0]
        this.adCode = currentCityInfo?.adcode
        this.handleMapZoomend()
      })
    },
    handleMapZoomend() {
      let zoom = this.map.getZoom()
      console.log("mapZoomend zoom" + zoom)
      let center = this.map.getCenter()
      this.mapMoveCenter = {
        latitude: center.lat,
        longitude: center.lng,
        valid: true
      }
      this.distance += this.calcDistance(this.mapMoveCenter, this.userPosition)
      this.noMore = false
      this.number++
      // this.getShopInfo("zoom", this.number)
      !this.loading && this.getShopInfoByMapAction()
    },
    getScreenDistance() {
      const bound = this.map.getBounds()
      return getDistance(bound.northeast, bound.southwest)
    },
    async getShopInfoByMapAction() {
      let data = {
        pageInfo: {
          page: this.page,
          pageSize: this.pageSize
        },
        params: {
          activityId: this.activityId,
          coordinates: this.mapMoveCenter ? this.mapMoveCenter : this.userPosition,
          location: this.userPosition,
          distance: this.getScreenDistance(),
          cateId: this.nowSelectCate.uid,
          adCode: this.adCode
        }
      }
      this.loading = true
      let res = await getShopInfo(data)
      if (!res) return
      res = res.map(item => {
        item.distance = getDistance(
          { lng: this.userPosition.longitude, lat: this.userPosition.latitude },
          { lng: item.address.point.x, lat: item.address.point.y }
        )
        return item
      })
      this.initShopIcon()
    },
    async getShopInfo(type, number) {
      if (this.noMore) {
        // 分页加载更多的时候或者初始化init缩放到一定范围以后（中国？）,数量 < 2
        this.refreshIcon = true
        this.map.on("moveend", this.moveMapend)
        this.map.on("zoomend", this.mapZoomend)
        type == "update" && this.toast("没有更多数据了")
        type !== "updata" && this.initShopIcon()
        return
      }
      if (!this.userPosition) {
        this.userPosition = this.defaultPosition
      }
      if (type !== "update") this.page = 0
      let data = {
        pageInfo: {
          page: this.page,
          pageSize: this.pageSize
        },
        params: {
          activityId: this.activityId,
          coordinates: this.mapMoveCenter ? this.mapMoveCenter : this.userPosition,
          location: this.userPosition,
          distance: this.getScreenDistance(),
          cateId: this.nowSelectCate.uid,
          adCode: this.adCode
        }
      }
      this.loading = true
      let res = await getShopInfo(data)
      if (!res) return
      res = res.map(item => {
        item.distance = getDistance(
          { lng: this.userPosition.longitude, lat: this.userPosition.latitude },
          { lng: item.address.point.x, lat: item.address.point.y }
        )
        return item
      })
      console.log("getShopInfo res: ", this.shopDataSet, res)
      if (number && this.number != number) {
        return
      }
      this.loading = false
      if (type == "update" && res.length < this.pageSize) {
        this.noMore = true
      }
      if (type == "update") {
        this.shopDataSet = this.shopDataSet.concat(res)
        this.initShopIcon()
      } else {
        this.shopDataSet = res
        this.shopDataSet = this.shopDataSet.map(item => item).sort((a, b) => a.distance - b.distance)
        type !== "init" && this.initShopIcon()
      }
      if (res && res.length > 0) {
        let distance = this.distance
        res = res.map(item => item).sort((a, b) => a.distance - b.distance)
        if (res[1]) {
          distance = res[1].distance * 500
        } else if (res[0]) {
          distance = res[0].distance * 500
        }
        if (res.length < 2 && type == "init") {
          //不断扩大范围搜索是否有两个
          this.map.off("moveend", this.moveMapend)
          this.map.off("zoomend", this.mapZoomend)
          this.distance += 100
          if (this.scale2Zoom(this.distance * 1000) > 3) {
            this.noMore = false
          } else {
            this.noMore = true
          }
          this.getShopInfo("init")
          this.map.setZoomAndCenter(this.scale2Zoom(distance), [this.userPosition.longitude, this.userPosition.latitude])
        } else {
          //数据点多于等于2的时候
          this.nowSelectedInfo = this.shopDataSet[0]
          if (type == "init") {
            this.map.off("moveend", this.moveMapend)
            this.map.off("zoomend", this.mapZoomend)
            this.map.setZoomAndCenter(this.scale2Zoom(distance), [this.userPosition.longitude, this.userPosition.latitude])
            this.initShopIcon()
          }
          this.refreshIcon = true
          this.map.on("moveend", this.moveMapend)
          this.map.on("zoomend", this.mapZoomend)
          this.hideLoading()
        }
      } else {
        if (type == "init") {
          //没有数据的时候
          this.map.off("moveend", this.moveMapend)
          this.map.off("zoomend", this.mapZoomend)
          this.distance += 100
          this.loopControl = this.scale2Zoom(this.distance * 1000) < 3
          if (!this.loopControl || this.distance < 3000) {
            //不断扩大范围搜索是否有数据
            this.map.setZoom(this.scale2Zoom(this.distance * 1000))
            this.getShopInfo("init")
          } else {
            this.distance = 20
            this.toast("该分类没有数据")
            this.shopDataSet = []
            this.initShopIcon()
          }
        }
        this.hideLoading()
      }
    },
    initShopIcon(mode) {
      if (mode !== "add") this.markerAndPolygons && this.map.remove(this.markerAndPolygons)
      let _data = this.shopDataSet
      let polygons = _data
        .filter(item => item.address.border?.length > 0)
        .map((item, index) => {
          let path = cleanPolygonData(item.address.border)?.map(pathItem => [pathItem.x, pathItem.y])
          let categorieColor = this.activityInfo.categories?.filter(categoryItem => categoryItem.uid === item.categoryId)[0]["blockColor"]
          let fillColor = changeRgbaToHex(categorieColor).color
          let fillOpacity = changeRgbaToHex(categorieColor).opacity
          const polygon = new AMap.Polygon({
            path: path,
            strokeColor: "#C52121",
            strokeWeight: 2,
            strokeOpacity: 0,
            fillOpacity,
            fillColor,
            zIndex: 50,
            extData: {
              id: item.id
            }
          })
          this.polygonInstances.push(polygon)
          return polygon
        })

      let markers = _data.map((item, index) => {
        let content = `<div data-id="${item.id}" class="icon shop-icon-box icon-marker">
                        <img class="icon-item default-icon" src="${this.matchIconImg(item)}" alt="" />
                        <p style="opacity: 0.7;" class="icon-item shop-name">${item.name}</p>
                       </div>`
        let marker = new AMap.Marker({
          position: [item.address.point.x, item.address.point.y],
          content,
          offset: new AMap.Pixel(0, 0),
          anchor: "bottom-center",
          extData: {
            id: item.id
          }
        })
        this.markerInstances.push(marker)
        return marker
      })

      this.markerAndPolygons = polygons.concat(markers)
      this.map.add(this.markerAndPolygons)
    },
    handleClickPolygon(item, polygon) {
      if (this.nowSelectedInfo === item) return
      this.nowSelectedInfo = item
      this.initAmapPolygon()
      this.initAmapMark()
      polygon.setOptions({ strokeOpacity: 0.5 })
    },
    initAmapPolygon() {
      this.polygonInstances.forEach(item => item.setOptions({ strokeOpacity: 0 }))
    },
    initAMap() {
      /* global AMap */
      this.map = new AMap.Map("map-container", {
        zoom: this.scale2Zoom(this.distance * 1000),
        center: [this.defaultPosition.longitude, this.defaultPosition.latitude],
        mapStyle: "amap://styles/macaron"
      })
      this.map.on("moveend", this.moveMapend)
      this.map.on("zoomend", this.mapZoomend)
      this.map.plugin("AMap.Geolocation", () => {
        this.showLoading()
        let geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: false, // 显示定位按钮，默认：true
          showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        })
        this.map.addControl(geolocation)
        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, "complete", this.onComplete) // 返回定位信息
        AMap.event.addListener(geolocation, "error", this.onError) // 返回定位出错信息
      })
      this.map.plugin("AMap.DistrictSearch", () => {
        var districtSearch = new window.AMap.DistrictSearch({
          level: "province",
          subdistrict: 2
        })
        districtSearch.search("广东省", (status, result) => {
          console.log("广东省行政信息", result)
          this.gdCityList = result.districtList[0].districtList
        })
      })
    },
    async onComplete(obj) {
      console.log("Amap geolocation onComplete", obj)
      this.hideLoading()
      this.userPosition = {
        latitude: obj.position.lat,
        longitude: obj.position.lng,
        valid: true
      }
      this.setUserPoint(obj.position.lng, obj.position.lat)
    },
    async onError(obj) {
      this.hideLoading()
      console.log("Amap geolocation onError", obj)
      this.setUserPoint(this.defaultPosition.longitude, this.defaultPosition.latitude)
    },
    async setUserPoint(lng, lat) {
      let userPoint = new AMap.Marker({
        position: new AMap.LngLat(lng, lat),
        title: "用户位置"
      })
      this.map.add(userPoint)
      await this.getShopInfo("init")
    }
  }
}
</script>

<style lang="scss">
.icon-marker {
  /**解决ios部分低版本手机无法点击到元素 */
  cursor: pointer;
}
// 覆盖amap的样式，让文字图标下的文字至少显示3rem
.amap-marker {
  width: 3rem !important;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}

.map-home {
  .back {
    width: 0.95rem;
    height: 0.66rem;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 0 0.38rem 0.38rem 0;
    position: fixed;
    left: 0;
    top: 50%;
    z-index: 9999;
    transform: translate(0, -50%);
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    line-height: 0.66rem;
    text-align: center;
    color: #ffffff;
    letter-spacing: 0;
  }
  .icon-item {
    transition: all 0.3s;
  }

  .shop-icon-box {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    .default-icon {
      display: block;
      height: 0.65rem;
      margin-bottom: 0.1rem;
    }

    .shop-name {
      max-width: 3rem;
      height: auto;
      line-height: 0.4rem;
      padding: 0.1rem 0.2rem;
      background: #ffffff;
      box-shadow: 0 0.04rem 0.08rem 0 rgba(113, 108, 98, 0.25);
      border-radius: 0.25rem;
      font-size: 0.26rem;
      color: #333333;
    }
  }

  .shop-icon-box-active {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    .default-icon {
      display: block;
      height: 1.2rem;
      margin-bottom: 0.1rem;
    }

    .shop-name {
      max-width: 3rem;
      height: auto;
      line-height: 0.4rem;
      padding: 0.1rem 0.2rem;
      background: rgba(0, 0, 0, 0.8);
      box-shadow: 0 0.04rem 0.08rem 0 rgba(113, 108, 98, 0.2);
      border-radius: 0.25rem;
      font-size: 0.26rem;
      color: #ffffff;
    }
  }

  .map-fake-container {
    .merchant-entry {
      position: fixed;
      font-size: 0;
      top: 1.9rem;
      right: 0;
      width: 1.4rem;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 998;
    }
    ._mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 90;
    }

    .banner {
      width: 7.5rem;
      height: 0.8rem;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    #map-container {
      width: 7.5rem;
      height: 100vh;
    }

    .fix-location {
      position: fixed;
      right: 0.2rem;
      bottom: 4.8rem;
      width: 0.68rem;
      height: 0.68rem;
      z-index: 90;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      box-shadow: 0 0.04rem 0.08rem 0 rgba(113, 108, 98, 0.25);
      border-radius: 0.06rem;

      img {
        width: 0.44rem;
        height: 0.46rem;
        display: block;
      }
    }

    .show-shoplist {
      width: 7.5rem;
      height: 9.5rem;
      box-shadow: 0 -0.04rem 0.08rem 0 rgba(113, 108, 98, 0.25);
      border-radius: 0.3rem 0.3rem 0 0;
      position: fixed;
      left: 0;
      bottom: 0;
      transform: translate(0, calc(100% - 1.2rem));
      transition: all 0.5s;
      z-index: 99;
      background: #f5f4f4;
      overflow: hidden;

      .header {
        width: 7.5rem;
        height: 1.2rem;
        border-radius: 0.3rem 0.3rem 0 0;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        background: #fff;
        border-bottom: 0.01rem solid #ddd;

        .bar {
          width: 1rem;
          margin-top: 0.2rem;
          height: 0.12rem;
          background: #ebeaea;
          border-radius: 0.06rem;
          margin-bottom: 0.27rem;
        }

        .text {
          font-size: 0.26rem;
          color: #666666;
          letter-spacing: 0;
          text-align: center;
        }
      }

      .list-container {
        width: 7.5rem;
        position: relative;

        .list {
          width: 7.5rem;
          height: 8.3rem;
          display: flex;
          align-items: center;
          flex-flow: column nowrap;
          justify-content: flex-start;
          overflow: scroll;
          -webkit-overflow-scrolling: touch;

          .list-item {
            width: 100%;
            min-height: auto;
            border-bottom: 1px solid #f5f4f4;
            // margin-bottom: 0.2rem;
          }
        }
      }
    }

    .slider-wrapper {
      width: 100%;
      height: 0.99rem;
      position: fixed;
      top: 1rem;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: 999;
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;
      .slider {
        position: absolute;
        left: 0;
        top: 0;
        width: auto;
        height: 0.99rem;
        .slider-item {
          cursor: pointer;
          display: inline-block;
          width: 2.36rem;
          height: 0.92rem;
          margin-left: 0.1rem;
        }
      }
    }

    .search-bar {
      width: 7.1rem;
      height: 0.76rem;
      background: #ffffff;
      box-shadow: 0 0.04rem 0.08rem 0 rgba(113, 108, 98, 0.25);
      border-radius: 0.38rem;
      position: fixed;
      top: 1rem;
      left: 50%;
      transform: translate(-50%, 0);
      font-size: 0.3rem;
      line-height: 0.76rem;
      z-index: 999;

      .channel {
        padding-left: 0.4rem;
      }

      .icon {
        width: 0.28rem;
        height: 0.18rem;
        position: absolute;
        top: 50%;
        right: 0.4rem;
        transition: all 0.5s;
      }

      .select-box {
        width: 7.1rem;
        background: #ffffff;
        box-shadow: 0 0.04rem 0.08rem 0 rgba(113, 108, 98, 0.2);
        border-radius: 0.3rem;
        margin-top: 0.1rem;
        max-height: 7.5rem;
        overflow: auto;

        li {
          height: 0.78rem;
          line-height: 0.78rem;
          font-size: 0.3rem;
          padding: 0 0.3rem;
        }
      }
    }
  }
}
</style>
